export default function MainLoader() {
    return (
        <div className="loader-anm">
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
            <div className="line line-4"></div>
            <div className="line line-5"></div>
            <div className="line line-6"></div>
        </div>
    )
}